import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import KeyStore from 'utils/KeyStore';
import client from 'services/apollo/ApolloClient';
import ModalUtils from 'utils/ModalUtils';

const useLogOut = () => {
    const keyStore = new KeyStore();
    const history = useHistory();
    const [executingLogOut, setExecutingLogOut] = useState(false);

    const logOut = async () => {
        try {
            setExecutingLogOut(true);
            const token = keyStore.getToken();
            const hashToken = keyStore.getHashToken();
            const { data } = await axios.post(
                `${process.env.REACT_APP_GRAPHQL_HTTP}/logout`,
                { hashToken },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        hashToken: hashToken || '',
                        'x-auth-type': 'oauth2',
                    },
                },
            );

            if (data?.success) {
                client.resetStore();
                keyStore.clear();
                history.push('/login');
            }
        } catch (error) {
            ModalUtils.errorMessage(null, error);
        } finally {
            setExecutingLogOut(false);
        }
    };

    return {
        logOut,
        executingLogOut,
    };
};

export default useLogOut;
